import React from "react";
import Loader from '../../../components/Loader';
import Page from '../../../components/Page';
import HTTPManager from "../../../utils/httpRequestManager";
import TableView from '../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import Iconify from '../../../components/Iconify';
import FormManager from "../../../components/formComponents/FormManager";
import schema from './schema.json';
import {Box, Grid, Card,  Container, Typography, Stack, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button} from '@mui/material';
import FButton from '../../../components/formComponents/components/button';
import { checkButtonAccess } from "../../../utils/protector";
const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class Employee extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            schema:{},
            employeelist:[],
            addForm: false,
            selectedEmployee:{},
            defaultcommission:{},
            openDialog: false,
            columns:[
                {
                    field: 'mEmployeeFirstName',
                    headerName: 'Name',
                    flex: 1,
                    minWidth: 180,
                    editable: false,
                    renderCell: (params) => {
                        const name = params.row.mEmployeeFirstName === '' ? '--'
                            : params.row.mEmployeeFirstName + ' ' + params.row.mEmployeeLastName;
                        const initials = params.row.mEmployeeFirstName
                            ? params.row.mEmployeeFirstName[0] + (params.row.mEmployeeLastName ? params.row.mEmployeeLastName[0] : '')
                            : '?';
                        const color = params.row.mEmployeeColorCode || '#0D1727';
                        return (
                            <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                <div style={{
                                    width:34, height:34, borderRadius:'50%',
                                    background: color, color:'#fff',
                                    display:'flex', alignItems:'center', justifyContent:'center',
                                    fontSize:'0.75rem', fontWeight:700, flexShrink:0,
                                }}>
                                    {initials.toUpperCase()}
                                </div>
                                <span style={{ fontWeight:500 }}>{name}</span>
                            </div>
                        );
                    }
                },
                {
                    field: 'mEmployeeEmail',
                    headerName: 'Email',
                    flex: 1.5,
                    minWidth: 200,
                    editable: false,
                    renderCell: (params) => (
                        <span style={{ color:'#555', fontSize:'0.875rem' }}>
                            {params.row.mEmployeeEmail === '' ? '--' : params.row.mEmployeeEmail}
                        </span>
                    )
                },
                {
                    field: 'mEmployeeRole',
                    headerName: 'Role',
                    flex: 0.8,
                    minWidth: 100,
                    editable: false,
                    renderCell: (params) => {
                        const role = params.row.mEmployeeRoleName || '--';
                        const roleColors = { Owner:'#C9A060', Admin:'#4E79A7', Manager:'#59A14F', Employee:'#6B7280' };
                        const bg = (roleColors[role] || '#6B7280') + '20';
                        const fg = roleColors[role] || '#6B7280';
                        return (
                            <span style={{
                                background: bg, color: fg,
                                padding:'3px 10px', borderRadius:'12px',
                                fontSize:'0.78rem', fontWeight:600,
                            }}>{role}</span>
                        );
                    }
                },
                {
                    field: 'mEmployeeCode',
                    headerName: 'PassCode',
                    flex: 0.7,
                    minWidth: 90,
                    editable: false,
                    renderCell: (params) => (
                        <span style={{
                            background:'#f4f4f4', padding:'3px 10px',
                            borderRadius:'8px', fontFamily:'monospace',
                            fontSize:'0.85rem', fontWeight:600, letterSpacing:'0.05em',
                        }}>{this.getPasscode(params.row)}</span>
                    )
                },
                {
                    field: 'Action',
                    headerName:'Actions',
                    flex:1,
                    minWidth:100,
                    renderCell: (params) => (
                        this.getActions(params)                    
                    ),
                }
            ],
            rolesList:[]
        }
        this.handleCloseform = this.handleCloseform.bind(this); 
        this.updateRecord = this.updateRecord.bind(this);
        this.getEmpslist = this.getEmpslist.bind(this);
        this.onRoleChange = this.onRoleChange.bind(this)
    }

    onRoleChange(values){
        console.log(values);
        if(values.mEmployeeRole!== undefined && values.mEmployeeRole !==''){
            var filtered = this.state.rolesList.filter(r=>r.roleId===values.mEmployeeRole);
            var schema = Object.assign({}, this.state.schema);
            var properties = Object.assign([], this.state.schema.properties);
            var props=[];
            var required = Object.assign([], this.state.schema.required)
            properties.forEach((field,i)=>{
                if(field.component === 'Permission' && filtered.length>0){ 
                    console.log(filtered, field)
                    field.value = filtered[0].rolePermissions !== undefined &&  filtered[0].rolePermissions !==null ? JSON.parse(filtered[0].rolePermissions):{};
                } 
                else{
                    field.value=values[field.name]
                }
                props.push(field);
                if(i === properties.length-1){ 
                    schema.force = true
                    console.log("FORM", props)
                    schema.required = required
                    schema.properties = props; 
                    this.setState({schema: schema},()=>{
                        this.setState({addForm: true})
                    })
                }
            })
        }
    }

    updateRecord(row, status){ 
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`merchant/employee/update`, {mEmployeeStatus: status, id: row.mEmployeeId}).then(res=>{
                //console.log(res.message);
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }

    getPasscode(row){
        var detail = window.localStorage.getItem('userdetail')
        if(detail !== '' && detail !== undefined && detail !=='{}'){
          var userdetail = JSON.parse(detail);
            if(userdetail.userRole === 'Owner' && row.mEmployeeRoleName === 'Owner'){
                return row.mEmployeeCode
            }
            else if(userdetail.userRole !== 'Owner' && row.mEmployeeRoleName === 'Owner'){
                return '****'
            }
            else{
                return row.mEmployeeCode;
            }
        }
        return ''
    }

    getActions(params){
        var detail = window.localStorage.getItem('userdetail')
        if(detail !== '' && detail !== undefined && detail !=='{}'){
          var userdetail = JSON.parse(detail);
        const btnBase = { border:'none', borderRadius:'8px', padding:'5px 14px', fontSize:'0.78rem', fontWeight:600, cursor:'pointer', marginRight:'6px' };
        const editBtn  = { ...btnBase, background:'#f0f4ff', color:'#0D1727', border:'1px solid #c5d0e6' };
        const deactBtn = { ...btnBase, background:'#0D1727', color:'#fff' };
        const actBtn   = { ...btnBase, background:'#2e7d32', color:'#fff' };

        return <div style={{display:'flex', alignItems:'center'}}>
            {params.row.mEmployeeRoleName !== 'Owner' && <>
               {(checkButtonAccess('Employee') === 'W' || userdetail.userRole==='Owner') &&
                 <button style={editBtn} onClick={()=>this.openEdit(params.row)}>Edit</button>}

               {(checkButtonAccess('Employee') === 'W' || userdetail.userRole==='Owner') &&
                params.row.mEmployeeStatus!==null && params.row.mEmployeeStatus.toString() === '1' &&
                 <button style={deactBtn} onClick={()=>this.updateRecord(params.row, '0')}>Deactivate</button>}

               {(checkButtonAccess('Employee') === 'W' || userdetail.userRole==='Owner') &&
                params.row.mEmployeeStatus!==null && params.row.mEmployeeStatus.toString() === '0' &&
                 <button style={actBtn} onClick={()=>this.updateRecord(params.row, '1')}>Activate</button>}

               {checkButtonAccess('Employee') !== 'W' && userdetail.userRole !=='Owner' && <span style={{color:'#aaa',fontSize:'0.8rem'}}>N/A</span>}
            </>}
            {params.row.mEmployeeRoleName === 'Owner' && <>
               {userdetail.userRole==='Owner' &&
                 <button style={editBtn} onClick={()=>this.openEdit(params.row)}>Edit</button>}
               {userdetail.userRole !=='Owner' && <span style={{color:'#aaa',fontSize:'0.8rem'}}>N/A</span>}
            </>}
        </div>
        }
    }
    componentDidMount(){ 
        this.setState({schema: schema},()=>{
            this.reloadData();
        })
    }
    handleCloseform(){
        this.setState({addForm: false})
    }
    openEdit(data){ 
        //console.log(data)
        // var schema = Object.assign({},schemaobj);// this.state.schema);
        var properties = Object.assign([], schema.properties);
        var props=[];
 
    //     var emppermissions={};
    //     if(data["mEmployeePermissions"] !== '' && data["mEmployeePermissions"] !== undefined){ 
    //         emppermissions = JSON.parse(data["mEmployeePermissions"])  
    //    }
        properties.forEach((field,i)=>{
            field.value = data[field.name]; 
            if(field.component !== 'Permission'){
                props.push(field);
            }
            if(data.mEmployeeRoleName === 'Owner' && field.name === 'mEmployeeEmail'){
             field.disabled = true;  
            }
            if(field.name === 'mEmployeeRole'){ 
                if(data['mEmployeeRoleName'] === 'Owner'){
                    field.disabled = true;  
                   field.data=[
                        {
                            label:'Owner',
                            value:data[field.name]
                        }
                   ]
                }
                else{
                    field.data= "merchant/getRoles"
                    field.disabled= false; 
                }
            } 
            if(i === properties.length-1){ 
                    if(data['mEmployeeRoleName'] === 'Owner'){
                        props.push( {
                            "component":"Permission", 
                            "permissionType": "Owner",
                            style:{display:'none'}, 
                            "permissions":[
                                {
                                    key:"Employee",
                                    label:"Employee Management",
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"Customer",
                                    label:"Customer Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"Inventory",
                                    label:"Inventory Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"GiftCard",
                                    label:"GiftCard Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"DefaultCommission",
                                    label:"Default Commission Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"DefaultDiscount",
                                    label:"Default Discount Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"Discount",
                                    label:"Discount Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"Tax",
                                    label:"Tax Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"EmpSettings",
                                    label:"Employee Specific Settings", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"LoyaltyPoints",
                                    label:"Loyalty Points", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },  
                                {
                                    key:"Transactions",
                                    label:"Transactions", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        }
                                    ]
                                }, 
                                {
                                    key:"Payout",
                                    label:"Payout Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        }, 
                                        {
                                            "label":"Pay",
                                            "Value" :"W"
                                        }, 
                                    ]
                                }, 
                                {
                                    key:"Report",
                                    label:"Reports", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        }, 
                                    ]
                                },  
                            ]
                        }) 
                    }
                    else{
                        console.log(data)
                        props.push( {
                            "component":"Permission", 
                            "permissionType": "Admin",
                            style:{display:'flex'},
                            "value" :  data["mEmployeePermissions"],
                            "permissions":[
                                {
                                    key:"Employee",
                                    label:"Employee Management",
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"Customer",
                                    label:"Customer Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"Inventory",
                                    label:"Inventory Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"GiftCard",
                                    label:"GiftCard Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"DefaultCommission",
                                    label:"Default Commission Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"DefaultDiscount",
                                    label:"Default Discount Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"Discount",
                                    label:"Discount Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"Tax",
                                    label:"Tax Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"EmpSettings",
                                    label:"Employee Specific Settings", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"LoyaltyPoints",
                                    label:"Loyalty Points", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },  
                                {
                                    key:"Transactions",
                                    label:"Transactions", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        }
                                    ]
                                }, 
                                {
                                    key:"Payout",
                                    label:"Payout Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        }, 
                                        {
                                            "label":"Pay",
                                            "Value" :"W"
                                        }, 
                                    ]
                                }, 
                                {
                                    key:"Report",
                                    label:"Reports", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        }, 
                                    ]
                                },  
                            ]
                        }) 
                    }
                props.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"id",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })
                schema.properties = props; 
                this.setState({schema: schema,selectedEmployee: data},()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }
    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest('merchant/getRoles').then(r=>{
                this.setState({rolesList:r.data})
            })
            this.httpManager.getRequest(`merchant/defaultcommission/get`).then(response=>{ 
                // this.openEdit(response.data); 
                if(response.data.length > 0){
                    this.setState({defaultcommission: response.data[0] }, ()=>{ 
                        this.getEmpslist()
                    });
                }
                else{
                    this.getEmpslist()
                }
            })
        })
    }

    getEmpslist(){
        this.httpManager.getRequest(`merchant/employee/get`).then(response=>{
            //console.log(response)
            this.setState({employeelist: response.data, isLoading: false});
        })
    }

    handleCloseDialog(){
        this.setState({openDialog: false})
    }

    openAdd(){
        if(this.state.defaultcommission.id){
            this.setState({schema: schema,selectedEmployee: {}},()=>{
                var schemaobj = Object.assign({}, schema);

                var properties = Object.assign([], this.state.schema.properties);
                var props=[];
                properties.forEach((field,i)=>{
                    delete field["value"];
                    field.disabled= false; 
                    if(field.component !== 'Permission'){
                        props.push(field);
                    }
                    if(field.name === 'mEmployeeRole'){  
                            field.data= "merchant/getRoles"
                            field.disabled= false;  
                    } 
                    if(i === properties.length-1){
                        props.push( {
                            "component":"Permission", 
                            "permissionType":"Admin",
                            style:{'display':'flex'},
                            "permissions":[
                                {
                                    key:"Employee",
                                    label:"Employee Management",
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"Customer",
                                    label:"Customer Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"Inventory",
                                    label:"Inventory Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"GiftCard",
                                    label:"GiftCard Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"DefaultCommission",
                                    label:"Default Commission Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"DefaultDiscount",
                                    label:"Default Discount Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"Discount",
                                    label:"Discount Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"Tax",
                                    label:"Tax Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                }, 
                                {
                                    key:"EmpSettings",
                                    label:"Employee Specific Settings", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"LoyaltyPoints",
                                    label:"Loyalty Points", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },  
                                {
                                    key:"Transactions",
                                    label:"Transactions", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        }
                                    ]
                                }, 
                                {
                                    key:"Payout",
                                    label:"Payout Management", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        }, 
                                    ]
                                }, 
                                {
                                    key:"Report",
                                    label:"Reports", 
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        }, 
                                    ]
                                },  
                            ]
                        })
                        schemaobj.properties = props;
                    }
                });
                this.setState({schema:schemaobj}, ()=>{
                    this.setState({addForm: true}) 
                })
            })
        }
        else{
            this.setState({openDialog: true})
        }
    }
    render(){
        return <Page title="Employees | Astro POS">
            {this.state.isLoading && <Loader show={this.state.isLoading} />}
            <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />
            {!this.state.addForm ?
                <Container maxWidth="xl">
                    {/* ── Header ── */}
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
                        <div>
                            <Typography variant="h4" style={{ fontWeight:700, color:'#0D1727' }}>
                                Employee Management
                            </Typography>
                            <Typography variant="body2" style={{ color:'#6B7280', marginTop:'2px' }}>
                                Manage your team members and their access
                            </Typography>
                        </div>
                        {checkButtonAccess('Employee') === 'W' &&
                            <button onClick={()=>this.openAdd()} style={{
                                display:'flex', alignItems:'center', gap:'6px',
                                background:'#0D1727', color:'#fff',
                                border:'none', borderRadius:'10px',
                                padding:'10px 20px', fontSize:'0.9rem', fontWeight:600,
                                cursor:'pointer', boxShadow:'0 2px 8px rgba(13,23,39,0.25)',
                            }}>
                                <span style={{fontSize:'1.1rem', lineHeight:1}}>+</span> Add Employee
                            </button>
                        }
                    </Stack>

                    {/* ── Table card ── */}
                    <div style={{
                        background:'#fff', borderRadius:'16px',
                        boxShadow:'0 2px 16px rgba(13,23,39,0.08)',
                        overflow:'hidden',
                    }}>
                        <TableView
                            data={this.state.employeelist}
                            columns={this.state.columns} />
                    </div>
                </Container> : ''
            }
            {this.state.addForm && <Box sx={{ width: '100%' }}> 
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                     <Grid item xs={12}> 
                        <Stack spacing={3}> 
                            <FormManager formFunctions={{
                                onRoleChange: this.onRoleChange, 
                            }} formProps={this.state.schema}  reloadData={(msg)=>this.reloadData(msg)} closeForm={()=>this.handleCloseform()}/>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>}


            <Dialog
                    open={this.state.openDialog}
                    onClose={this.handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Error
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                       Please set default commission and create employees.
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={()=>{
                            this.handleCloseDialog()
                        }}>  OK </Button> 
                    </DialogActions>
                </Dialog>

            </Page>  
    }


}